import { useCallback, useEffect, useState } from "react";

/* FAボタンの制御 */
export const useFaButton = (autoHidden?: boolean) => {
  const [btnHidden, setBtnHidden] = useState(false);

  //スクロールが最下部付近まで達しているかチェック
  const checkScrollY = useCallback(() => {
    const doc = document.body;
    const docHeight = doc.scrollHeight - doc.clientHeight;
    if (window.scrollY + 50 > docHeight && autoHidden) {
      setBtnHidden(true);
    } else {
      setBtnHidden(false);
    }
  }, []);

  //スクロールチェックイベントの登録
  useEffect(() => {
    window.addEventListener("scroll", checkScrollY);
    return () => {
      window.removeEventListener("scroll", checkScrollY);
    };
  }, []);

  return { btnHidden };
};
